
const util = require('util');

const FormModelBase = require('./base-model');


function EmailbackFormModel () {
	const self = FormModelBase.apply(this, arguments);

	self.Email.extend({
		required: true,
	});

	return self;
}

util.inherits(EmailbackFormModel, FormModelBase);

module.exports = EmailbackFormModel;

